module.exports = __webpack_public_path__ + "static/media/LogoDE.e0c56543.svg";